import React from 'react'
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import AvpHeader from '../shared/header/AvpHeader';
import BreadCrumb from '../shared/header/BreadCrumb';
import { DataGrid } from '@mui/x-data-grid';
import { userIsLogged, getRoute, apiGetAllSysLingue } from "../shared/manager/api_manager";
import { useEffectOnce } from '../shared/manager/use_effect_once';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneLingueScreen() {  

  const navigate = useNavigate();

  const [rows, setRows] = useState([])
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);

     const { selectedLinguaTesto } = useLingueStore(
      (state) => state
    );

  const breadCrumb = [
    { title: selectedLinguaTesto?.GestioneLingueBreadcrumb1, link:'/sistema' },
    { title: selectedLinguaTesto?.GestioneLingueBreadcrumb2, link:null }
  ];

  useEffectOnce(() => {
    startPage();
    
    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");

    if (userIsLogged()==false) {
      navigate("/login");
    }else{
      var route = getRoute();
      if(!route.funzioni.some(g => g.idFunzione === 40)) {
          navigate("/"); 
      }
      initPage();
    }

    
  }

  function initPage() {
    console.log("initPage");

    apiGetAllSysLingue(function(response) {
      if (response!=null && response.status>=200 && response.status<400) {
        setRows(response.data); 
      }
      else {
        setRows([]); 
      }
    });


  }

  function stopPage() {
    console.log("stopPage");

  }



  const columns = [
    { field: 'codLingua', headerName:selectedLinguaTesto?.GestioneLingueColumnCodLang, flex: 2, headerClassName: 'tableHeader' },
    { field: 'descrizione', headerName: selectedLinguaTesto?.GestioneLingueColumnDesc, flex: 2, headerClassName: 'tableHeader' },
    { field: 'action', headerName:'', flex: 2, sortable: false, headerClassName: 'tableHeader', align:'right',
      renderCell: (params) => {
        
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          console.log(params.row);
          const action = event.target.dataset.action;
          if (action=="edit") {
            handleEdit(params.row.idLingua)
          }
        //   else
        //   if (action=="delete") {
        //     handleDelete(params.row.idLingua);
        //   }
        //   else
        //   if (action=="restore") {
        //     handleRestore(params.row.idLingua);
        //   }          

        };
  
        return <div className="tableActionButton">
            <img data-action="edit" src="/images/edit_btn.svg" title={selectedLinguaTesto?.GestioneLingueImgEdit} onClick={onClick} />
            {/* <img data-action="delete" data-rowid="" src="/images/delete_btn.svg" onClick={onClick} style={{ display : (params.row.sysAttivo ? "inline" : "none") }} /> */}
            {/* <img data-action="restore" data-rowid="" src="/images/restore_user.svg" onClick={onClick} style={{ display : (params.row.sysAttivo ? "none" : "inline") }}  /> */}
          </div>;
      }
    }

  ];

  function handleNew() {
    const dest = "/sistema/lingue/-1";
    navigate(dest);
  }


  function handleEdit(idLingua) {
    const dest = "/sistema/lingue/"+idLingua;
    navigate(dest);
  }

//   function handleDelete(idLingua) {
//     setIdToDelete(idLingua);
//     setDeleteDialogOpen(true);
//   }

//   function handleRestore(idLingua) {
//     let language = null;
//     if (rows!=null && rows.length>0) {
//       for (var i=0; i<rows.length; i++) {
//         if (rows[i].idLingua==idLingua) {
//             language = rows[i];
//           break;
//         }
//       }
//     }

//     if (language!=null) {
//       language.sysAttivo = true;
//       apiPostAvpLingua(language, function(response) {
//         if (response!=null && response.status>=200 && response.status<400) {
//           setAlertSuccessOpen(true);
//           setAlertErrorOpen(false);
//           initPage();
//         }
//         else {
//           setAlertSuccessOpen(false);
//           setAlertErrorOpen(true);
//         }
//       });
//     }
//   }

//   const handleDeleteDialogClose = () => {
//     setDeleteDialogOpen(false);
//   };

//   const handleDeleteDialogConfirm = () => {
//     setDeleteDialogOpen(false);

//     apiDeleteAnaGruppoUtente(idToDelete, function(response) {
//       if (response!=null && response.status>=200 && response.status<400) {
//         setAlertSuccessOpen(true);
//         setAlertErrorOpen(false);
//         initPage();
//       }
//       else {
//         setAlertSuccessOpen(false);
//         setAlertErrorOpen(true);
//       }
//     });
//   };

  function handleUtentiTab() {
    const dest = "/sistema";
    navigate(dest);
  }

  return (
    <div id="avp-gestioneavp-screen"  >
      <AvpHeader selectedMenuId={"sistema"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#sistema"} />
      <div id="avp-cms-screen-container"  >
        <Collapse in={alertSuccessOpen} timeout={{ enter: 1000, exit: 1000 }}  addEndListener={() => { setTimeout(() => {setAlertSuccessOpen(false)}, 2000); }  }>
          <Alert variant="filled" severity="success" onClose={ () => {setAlertSuccessOpen(false)} }>
           {selectedLinguaTesto?.GestioneLingueDialogSuccess}
          </Alert>
        </Collapse>  
        <Collapse in={alertErrorOpen}>
          <Alert variant="filled" severity="error" onClose={ () => {setAlertErrorOpen(false)} }>
            {selectedLinguaTesto?.GestioneLingueDialogError} 
          </Alert>
        </Collapse> 

        <div className="avp-cms-tab clearfix" >
            <div className={'avp-cms-tab-item'} onClick={handleUtentiTab} >
             {selectedLinguaTesto?.GestioneLingueTabSystem} 
            </div>   
            <div className={'avp-cms-tab-item avp-cms-tab-item-selected'} >
            {selectedLinguaTesto?.GestioneLingueTabLang}  
            </div>              
        </div>

        <div className="avp-cms-screen-title">{selectedLinguaTesto?.GestioneLingueTitle}</div>
        <div className="avp-cms-screen-content"  >
          
          <div className="avp-cms-screen-toolbar clearfix"  >
            <div className="avp-cms-screen-toolbar-title"  >{rows.length}&nbsp;{selectedLinguaTesto?.GestioneLingueSubtitle}</div>
            <div className="avp-cms-screen-toolbar-filters"  ></div>
            <div className="avp-cms-screen-toolbar-add" onClick={handleNew} ><button>{selectedLinguaTesto?.GestioneLingueButtonNew}</button></div>
          </div >

          {/* <div className="avp-cms-screen-content-row clearfix">

              <div className="avp-cms-screen-content-column"  >
                  <label htmlFor="avp-form-tipofile" >Stato</label><br/>
                  <select id="avp-form-tipofile" value={utentiStatus} onChange={onUtentiStatusChange}>
                      <option key={0} value="0"  >Attivi</option>
                      <option key={1} value="1"  >Non attivi</option>
                  </select> 
              </div> 
          </div>  */}

          <DataGrid
          disableColumnMenu
          getRowId={(row) => row.idLingua}
          rows={rows}
          columns={columns}
          getRowClassName={(params) =>
            'tableRow'
          }
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 20,
              },
            },
          }}
          pageSizeOptions={[20, 30, 50]}
          disableRowSelectionOnClick
        />
        </div>
      </div>

      {/* <Dialog
          open={deleteDialogOpen}
          onClose={handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">
          {"Conferma disabilitazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Vuoi disabilitare la lingua selezionata?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} >NO</Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>SI</Button>
        </DialogActions>
      </Dialog> */}
    </div>     
  ); 

} 